<template lang="pug">
  select(:value="value", @input="$emit('input', $event.target.value)")
    option(:value="null") Please select an {{ type }}
    option(v-for="i in items", :value="i.id") {{ i.name }}
</template>

<script>
export default {
  name: 'LocationSelect',

  props: {
    type: {
      type: String,
      required: true
    },
    value: {
      type: String
    }
  },

  computed: {
    items () {
      return this.$store.state[this.type].all
    }
  }
}
</script>
